import { Banner, Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { openHistoricalParallelMachinePairsMatrixModal } from './HistoricalParallelMachinePairsMatrixModal';
import { useFaro } from '@nexelem/grafana';

type HistoricalParallelMachinePairsPreviewProps = {
  machineAreaId: number | undefined;
  lookbackMonths: number;
  minOverlapsForPairPerMonth: number;
};

export const HistoricalParallelMachinePairsPreview = ({
  machineAreaId,
  lookbackMonths,
  minOverlapsForPairPerMonth,
}: HistoricalParallelMachinePairsPreviewProps) => {
  const faro = useFaro();
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');

  if (machineAreaId === undefined || machineAreaId <= 0) {
    return <Banner message={tWrapper('policy.parallelPairs.selectArea')} type="warning" />;
  }

  return (
    <Button
      type="button"
      variant="outlined"
      onClick={() => {
        faro?.api.pushEvent('auto_assignment_event', {
          type: 'button_click',
          button_name: 'show_matrix',
        });

        return openHistoricalParallelMachinePairsMatrixModal({
          machineAreaId,
          lookbackMonths,
          minOverlapsForPairPerMonth,
        });
      }}
    >
      {tWrapper('policy.parallelPairs.showMatrix')}
    </Button>
  );
};
